module.exports = "/_next/static/images/86bb26f69e66b315f2f8d9cec4862379-device-frame@1x.png";